import type { SearchableSelectOption } from '@/components/ui/SearchableSelect'

export const PAYMENT_STATUS_FILTER_OPTIONS: SearchableSelectOption[] = [
  { value: 'OnHold', label: 'OnHold' },
  { value: 'PendingPaymentAuthorization', label: 'Liberty Pending' },
  { value: 'ExternalPending', label: 'External Pending' },
  { value: 'ACH_Check_Pending', label: 'ACH Check Pending' },
  { value: 'Completed', label: 'Completed' },
  { value: 'Cancelled', label: 'Cancelled' },
  { value: 'Recovered', label: 'Recovered' },
]

export const CLAIM_STATUS_SELECT_OPTIONS: SearchableSelectOption[] = [
  { value: 'NOT_STARTED', label: 'Not Started' },
  { value: 'IN_PROGRESS', label: 'In Progress' },
  { value: 'RECEIVED', label: 'Received' },
  { value: 'DENIED', label: 'Denied' },
  { value: 'UNDER_REVIEW', label: 'Under Review' },
  { value: 'RE_OPENED', label: 'Re-Opened' },
  { value: 'VERIFICATION_NEEDED', label: 'Verification Needed' },
  { value: 'LIBERTY_REVIEW', label: 'Liberty Review' },
  { value: 'EXTERNAL_REVIEW', label: 'Level 3 Review' },
  { value: 'PAYMENT_PENDING', label: 'Payment Pending' },
  { value: 'PAID', label: 'Paid' },
  { value: 'CANCELLED', label: 'Cancelled' },
]

export const YES_NO_FILTER_OPTIONS: SearchableSelectOption[] = [
  { value: '1', label: 'Yes' },
  { value: '0', label: 'No' },
]

export const PAYMENT_SOURCE_FILTER_OPTIONS: SearchableSelectOption[] = [
  { value: 'PAYPAL', label: 'Paypal' },
  { value: 'CARDCONNECT', label: 'CardConnect' },
  { value: 'PAYNEARME', label: 'PayNearMe' },
  { value: 'EXTERNAL', label: 'External Payment' },
]

export const SPECIAL_NOTE_FILTER_OPTIONS: SearchableSelectOption[] = [
  { value: 'COVID_19', label: 'Covid 19' },
]

export const TOTAL_CONTRACTS_PAYMENT_STATUS_OPTIONS: SearchableSelectOption[] = [
  { value: 'ACH_Check_Pending', label: 'ACH Check Pending' },
  { value: 'Approved', label: 'Approved' },
  { value: 'AuthorizationPending', label: 'Authorization Pending' },
  { value: 'Completed', label: 'Completed' },
  { value: 'Failed', label: 'Failed' },
  { value: 'Pending', label: 'Pending' },
  { value: 'Processing', label: 'Processing' },
  { value: 'Rejected', label: 'Rejected' },
]

export const RENTAL_STATUS_OPTIONS: SearchableSelectOption[] = [
  { value: 'ACTIVE', label: 'Active' },
  { value: 'SKIPPED', label: 'Skipped' },
  { value: 'EVICTION', label: 'Eviction' },
  { value: 'NOT_STARTED', label: 'Not Started' },
  { value: 'CLOSED', label: 'Closed' },
]

export const WEEK_FILTER_OPTIONS: SearchableSelectOption[] = [
  { value: 'under_review', label: 'Under Review' },
  { value: 'doc_uploaded', label: 'Docs Uploaded' },
]
